import { type NamespaceTester } from "src/lib/i18next/types.ts";
import { exceptions } from "src/lib/i18next/testers/exceptions.ts";
import { component } from "src/lib/i18next/testers/component.ts";
import { resourceList } from "src/lib/i18next/testers/resource-list.ts";
import { resource } from "src/lib/i18next/testers/resource.ts";
import { resourceForm } from "src/lib/i18next/testers/resource-form.ts";
import { module } from "src/lib/i18next/testers/module.ts";
import { resourceFormTab } from "src/lib/i18next/testers/resource-form-tab.ts";

export const getTranslationsPath = (
  ns: string,
  lang: string,
): null | string => {
  const testers: NamespaceTester[] = [
    exceptions,
    resource,
    resourceList,
    resourceForm,
    module,
    resourceFormTab,
    component,
  ];

  for (let i = 0; testers.length > i; i++) {
    const tester = testers[i];
    const path = tester(ns, lang);
    if (path) {
      return path;
    }
  }

  return null;
};
